import React from 'react';
import { useStringsContext } from '../../../../../contexts/strings';
import { Poll } from '../../types';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import moment from 'moment';
import Chip from '@mui/material/Chip';
import BaseDialog from '../../../../common/base-dialog';

interface Props {
  open: boolean;
  selectedPoll: Poll;
  onClose: () => void;
}

const PollCreatedModal = ({ open, onClose, selectedPoll }: Props) => {
  const { strings } = useStringsContext();

  return (
    <BaseDialog open={open} onClose={onClose} title={strings.polls.createdTitle}>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Box>
            <Typography variant="body2">{strings.polls.createdActive}</Typography>
            <Typography variant="body2-bold">{`${moment(selectedPoll.startTime).format('YYYY-MM-DD HH:mm')} - ${moment(selectedPoll.endTime).format('YYYY-MM-DD HH:mm')}`}</Typography>
          </Box>
          <Typography variant="body2-bold">{strings.polls.createdNextSteps}</Typography>
          <Stack spacing={2}>
            {[
              strings.polls.createdStepOne,
              strings.polls.createdStepTwo,
              strings.polls.createdStepThree,
            ].map((text, index) => (
              <Stack key={index} direction="row" spacing={4} alignItems="center">
                <Chip label={index + 1} variant="outlined" />
                <Typography variant="body2">{text}</Typography>
              </Stack>
            ))}
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={onClose}>
          {strings.actions.close}
        </Button>
      </DialogActions>
    </BaseDialog>
  );
};

export default PollCreatedModal;
